// NOTE: If you are adding a new color variable, please add it to /common/_variables.less
// to make sure they are in sync

// Colors
const COLOR_ALABASTER = '#fcfcfc';
const COLOR_ALICE_BLUE = '#f5f9fc';
const COLOR_ALTO = '#d9d9d9';
const COLOR_APRICOT = '#fac0ac';
const COLOR_AQUA_SPRING_BLUE = '#ecf7f9';
const COLOR_BAY_BLUE = '#0f5c82';
const COLOR_BLACK = '#21201f';
const COLOR_BLUE = '#0075ae';
const COLOR_BLUSH = '#ffebf8';
const COLOR_BOULDER = '#767676';
const COLOR_CLOUD = '#f9f9f9';
const COLOR_COVE_BLUE = '#55a1bf';
const COLOR_DARKER_SHADOW = 'rgba(0, 0, 0, 0.1)';
const COLOR_EASTERN_BLUE = '#179caa';
const COLOR_EMPEROR = '#505050';
const COLOR_EVERGREEN = '#15845D';
const COLOR_FLORAL_WHITE = '#fffbe8';
const COLOR_FOREST = '#005759';
const COLOR_GEYSER = '#f5f7fa';
const COLOR_GRAY_2 = '#f8f8f8';
const COLOR_GREEN = '#acc05a';
const COLOR_ICE_BLUE = '#c8e3ec';
const COLOR_JADE = '#7ebeae';
const COLOR_LIGHT_GREEN = '#bdd08e';
const COLOR_LIGHTER_SHADOW = 'rgba(0, 59, 88, 0.1)';
const COLOR_LILAC = '#f9fafc';
const COLOR_LILAC_2 = '#d9cafc';
const COLOR_LIME = '#d9edbf';
const COLOR_MARINE_BLUE = '#183b54';
const COLOR_MAUVE = '#77133f';
const COLOR_MELON = '#feaaa8';
const COLOR_MID_PURPLE = '#ae759e';
const COLOR_MINT = '#d7f5d9';
const COLOR_MINT_GREEN = '#d3ebe3';
const COLOR_NAVY = '#003b58';
const COLOR_ORANGE_PEEL = '#ff9a00';
const COLOR_PACIFIC_BLUE = '#01b4c0';
const COLOR_PALE_JADE = '#7dbba9';
const COLOR_PALE_ORANGE = '#F38258';
const COLOR_PALE_YELLOW = '#ffebb1';
const COLOR_PEACH = '#f7d7d2';
const COLOR_PEE_YELLOW = '#fffade';
const COLOR_PERIWINKLE = '#D4DEF0';
const COLOR_PINK = '#FDF0F1';
const COLOR_PLUM = '#733658';
const COLOR_PRIVILEGE = '#f7f7f7';
const COLOR_PURPLE = '#955C85';
const COLOR_RED_MESSAGING = '#B20033';
const COLOR_ROSE_2 = '#c7305b';
const COLOR_SCREAMING_GREY = '#aaaaaa';
const COLOR_SHIRAZ_RED = '#b20033';
const COLOR_SKY_BLUE = '#89fafc';
const COLOR_SOFT_PINK = '#fcd6d3';
const COLOR_TEA_GREEN = '#d8e8bb';
const COLOR_WHISPER = '#eee';
const COLOR_WHITE = '#FFF';
const COLOR_YELLOW = '#ffe45c';

const COLORS = {
  ALABASTER: COLOR_ALABASTER,
  ALICE_BLUE: COLOR_ALICE_BLUE,
  ALTO: COLOR_ALTO,
  APRICOT: COLOR_APRICOT,
  AQUA_SPRING_BLUE: COLOR_AQUA_SPRING_BLUE,
  BACKGROUND_JEWEL_4: COLOR_ALICE_BLUE,
  BACKGROUND_LIGHT_GRAY: COLOR_WHISPER,
  BAY_BLUE: COLOR_BAY_BLUE,
  BLACK: COLOR_BLACK,
  BLUE: COLOR_BLUE,
  BLUSH: COLOR_BLUSH,
  BOULDER: COLOR_BOULDER,
  CLOUD: COLOR_CLOUD,
  COVE_BLUE: COLOR_COVE_BLUE,
  DARKER_SHADOW: COLOR_DARKER_SHADOW,
  EASTERN_BLUE: COLOR_EASTERN_BLUE,
  EMPEROR: COLOR_EMPEROR,
  EVERGREEN: COLOR_EVERGREEN,
  FLORAL_WHITE: COLOR_FLORAL_WHITE,
  FOREST: COLOR_FOREST,
  GEYSER: COLOR_GEYSER,
  GREEN: COLOR_GREEN,
  ICE_BLUE: COLOR_ICE_BLUE,
  JADE: COLOR_JADE,
  LIGHT_GREEN: COLOR_LIGHT_GREEN,
  LIGHTER_SHADOW: COLOR_LIGHTER_SHADOW,
  LILAC_2: COLOR_LILAC_2,
  LIME: COLOR_LIME,
  LINK_HOVER: COLOR_BLUE,
  LINK: COLOR_BLUE,
  MARINE_BLUE: COLOR_MARINE_BLUE,
  MAUVE: COLOR_MAUVE,
  MELON: COLOR_MELON,
  MID_PURPLE: COLOR_MID_PURPLE,
  MINT: COLOR_MINT,
  MINT_GREEN: COLOR_MINT_GREEN,
  NAVY: COLOR_NAVY,
  ORANGE_PEEL: COLOR_ORANGE_PEEL,
  PACIFIC_BLUE: COLOR_PACIFIC_BLUE,
  PALE_JADE: COLOR_PALE_JADE,
  PALE_ORANGE: COLOR_PALE_ORANGE,
  PALE_YELLOW: COLOR_PALE_YELLOW,
  PEACH: COLOR_PEACH,
  PERIWINKLE: COLOR_PERIWINKLE,
  PINK: COLOR_PINK,
  PLUM: COLOR_PLUM,
  PRIVILEGE: COLOR_PRIVILEGE,
  PURPLE: COLOR_PURPLE,
  RED_MESSAGING: COLOR_RED_MESSAGING,
  ROSE_2: COLOR_ROSE_2,
  SCREAMING_GREY: COLOR_SCREAMING_GREY,
  SHIRAZ_RED: COLOR_SHIRAZ_RED,
  SKY_BLUE: COLOR_SKY_BLUE,
  SOFT_PINK: COLOR_SOFT_PINK,
  TEA_GREEN: COLOR_TEA_GREEN,
  WHISPER: COLOR_WHISPER,
  WHITE: COLOR_WHITE,
  YELLOW: COLOR_YELLOW,
};

// Brand Colors from Zola Design System Documentation
// https://www.figma.com/file/kzG9IDk1npM79QRzaU9XUh/Zola-Design-System-Documentation?node-id=98%3A5712
export const COLORS_BRAND = {
  DARK_TEAL: COLOR_EASTERN_BLUE,
  TEAL: COLOR_PACIFIC_BLUE,
};

// Text colors from Zola Design System Documentation
// https://www.figma.com/file/kzG9IDk1npM79QRzaU9XUh/Zola-Design-System-Documentation?node-id=98%3A5712
export const COLORS_TEXT = {
  BODY: COLOR_EMPEROR,
  DISABLED: COLOR_ALTO,
  PLACEHOLDER: COLOR_SCREAMING_GREY,
  PRIMARY: COLOR_BLACK,
  SECONDARY: COLOR_BOULDER,
};

// Link colors from Zola Design System Documentation
// https://www.figma.com/file/kzG9IDk1npM79QRzaU9XUh/Zola-Design-System-Documentation?node-id=98%3A5712
export const COLORS_LINK = {
  INVERTED: COLOR_WHITE,
  PRESSED: COLOR_NAVY,
  PRIMARY: COLOR_BLUE,
  SECONDARY: COLOR_EMPEROR,
};

// Messaging colors from Zola Design System Documentation
// https://www.figma.com/file/kzG9IDk1npM79QRzaU9XUh/Zola-Design-System-Documentation?node-id=98%3A5712
export const COLOR_SEMANTIC = {
  NEGATIVE: COLOR_SHIRAZ_RED,
  POSITIVE: COLOR_EVERGREEN,
  WARNING_BACKGROUND: COLOR_PEE_YELLOW,
  WARNING_PRIMARY: COLOR_ORANGE_PEEL,
  WARNING_SECONDARY: COLOR_YELLOW,
};

// Background colors from Zola Design System Documentation
// https://www.figma.com/file/kzG9IDk1npM79QRzaU9XUh/Zola-Design-System-Documentation?node-id=98%3A5712
export const COLORS_BACKGROUND = {
  APRICOT: COLOR_APRICOT,
  BAY_BLUE: COLOR_BAY_BLUE,
  BLUE: COLOR_ICE_BLUE,
  COVE_BLUE: COLOR_COVE_BLUE,
  CLOUD: COLOR_CLOUD,
  DARK_GRAY: COLOR_SCREAMING_GREY,
  FOREST: COLOR_FOREST,
  GRAY_2: COLOR_GRAY_2,
  ILLUSTRATIVE: '#f6f5f0',
  JEWEL_4: COLOR_ALICE_BLUE,
  JEWEL_8: '#EBF4F9',
  LIGHT_GRAY: COLOR_WHISPER,
  LILAC: COLOR_LILAC,
  LIME: COLOR_LIME,
  MARINE_BLUE: COLOR_MARINE_BLUE,
  MAUVE: COLOR_MAUVE,
  MELON: COLOR_MELON,
  NAVY: COLOR_NAVY,
  OUTLINE_GRAY: COLOR_ALTO,
  PEACH: COLOR_PEACH,
  PERIWINKLE: '#c9d6ec', // TODO: should this be COLOR_PERIWINKLE
  PLUM: COLOR_PLUM,
  ROSE_2: COLOR_ROSE_2,
  WHITE: COLOR_WHITE,
};

export const COLORS_VARIANTS = {
  APRICOT_12: '#fef7f5',
  APRICOT_24: '#fef0eb',
  APRICOT_40: '#fde6de',
  APRICOT_60: '#fcd9cd',
  APRICOT_8: '#fffaf9',
  APRICOT_80: '#fbcdbd',
  JEWEL_12: '#e0eef5',
  JEWEL_24: '#c2deec',
  JEWEL_40: '#99c8df',
  JEWEL_60: '#66acce',
  JEWEL_8: '#EBF4F9',
  JEWEL_80: '#3391be',
  LIME_12: '#fafcf7',
  LIME_24: '#f6fbf0',
  LIME_40: '#f0f8e5',
  LIME_60: '#e8f4d9',
  LIME_8: '#fcfefa',
  LIME_80: '#e1f1cc',
  MELON_12: '#fef4f4',
  MELON_24: '#ffebea',
  MELON_40: '#ffdddc',
  MELON_60: '#fecccb',
  MELON_8: '#fff9f8',
  MELON_80: '#febbb9',
  PERIWINKLE_12: '#f8fafc',
  PERIWINKLE_24: '#f2f5fb',
  PERIWINKLE_40: '#e9eff7',
  PERIWINKLE_60: '#dfe6f4',
  PERIWINKLE_8: '#fbfcfe',
  PERIWINKLE_80: '#d4def0',
};

export default COLORS;
